import { filterFns as tanstackFilterFns } from '@tanstack/react-table';
import { wrapNewCheckFilterFn } from './filterFns';

// Type-safe monkeypatch for built-in filterFns
(
  Object.keys(tanstackFilterFns) as Array<keyof typeof tanstackFilterFns>
).forEach((key) => {
  tanstackFilterFns[key] = wrapNewCheckFilterFn(tanstackFilterFns[key]);
});
